module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Raron-4ea2037f37a08b57e6180d401b6928d2.gif";